import React from "react";
import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import BlogComp from "../../component/servicescomponent/BlogComp";

const Blog = () => {
  return (
    <>
      <section className="usp_service_section">
        <Navbar />
        <BlogComp />
        <Footer />
      </section>
    </>
  );
};

export default Blog;
